"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

/**
 * Renders current time before timeout.
 *
 * @param {object} props
 * @param {number} props.ms
 * @param {function (): void} props.onOut
 * @param {number} [props.frameTimeMs=1000]
 * @returns {JSX.Element}
 *
 * @example
 * const PerfectTimer = () => {
 *   const handleTimeOut = useCallback(
 *     () => {
 *       alert('Time is out!');
 *     },
 *     []
 *   );
 *
 *   return <Timeout ms={30000} onOut={handleTimeOut} />;
 * }
 */
var Timeout = function Timeout(_ref) {
  var ms = _ref.ms,
      onOut = _ref.onOut,
      _ref$frameTimeMs = _ref.frameTimeMs,
      frameTimeMs = _ref$frameTimeMs === void 0 ? 1000 : _ref$frameTimeMs;
  var intervalId = (0, _react.useRef)(null);
  var start = (0, _react.useMemo)(function () {
    return Date.now();
  }, []);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      delta = _useState2[0],
      setDelta = _useState2[1];

  (0, _react.useEffect)(function () {
    intervalId.current = setInterval(function () {
      return setDelta(Date.now() - start);
    }, frameTimeMs);
    return function () {
      clearInterval(intervalId.current);
    };
  }, [frameTimeMs, start]);
  (0, _react.useEffect)(function () {
    if (ms <= delta) {
      onOut();
      clearInterval(intervalId.current);
    }
  }, [delta, ms, onOut]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, Math.ceil((ms - delta) / 1000));
};

Timeout.propTypes = {
  ms: _propTypes["default"].number.isRequired,
  frameTimeMs: _propTypes["default"].number,
  onOut: _propTypes["default"].func.isRequired
};
Timeout.defaultProps = {
  frameTimeMs: 1000
};
var _default = Timeout;
exports["default"] = _default;